import React from 'react';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';

// Import Images
import offlineImg from "../../../assets/images/logo-light.png";

const Offlinepage = () => {
    document.title = "Em Construção | Líder Fibra";
    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row className="justify-content-center">
                            <Col xl={5}>
                                <Card className="overflow-hidden">
                                    <CardBody className="p-4">
                                        <div className="text-center">
                                            <img src={offlineImg} alt="" style={{width:"70%"}} className='pb-4 pt-4'/>
                                            <h3 className="mt-4 fw-semibold">Página em construção</h3>
                                            <p className="text-muted mb-4 fs-14">Por favor aguarde enquanto trabalhamos para colocar esse serviço no ar para você.</p>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Offlinepage;